import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { appActions } from '../../../actions';

import AdminPageLayout from '../layout';
import ContactForm from './form';

class ContactNewPage extends React.PureComponent {
  async componentDidMount() {
    this.props.finishLoading();
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <AdminPageLayout>
          <div className="main-content">
            <h1>Create New Contact</h1>
            <ContactForm mode="create" />
          </div>
        </AdminPageLayout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  finishLoading: () => dispatch(appActions.finishLoading()),
});

ContactNewPage.propTypes = {
  finishLoading: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

const StyledContactNewPage = styled(ContactNewPage)`
`;

export default connect(
  null,
  mapDispatchToProps,
)(StyledContactNewPage);
